const Vue = window.Vue

Vue.component("NostoSearchForm", () => import("./app/components/search/NostoSearchForm.vue"))
Vue.component("NostoBrandSearchForm", () => import("./app/components/search/NostoBrandSearchForm.vue"))
Vue.component("NostoItemGridList", () => import("./app/components/itemList/NostoItemGridList.vue"))
Vue.component("NostoFilterList", () => import("./app/components/itemList/filter/NostoFilterList.vue"))
Vue.component("NostoFilterTagList", () => import("./app/components/itemList/filter/NostoFilterTagList.vue"))
Vue.component("NostoPagination", () => import("./app/components/itemList/partials/NostoPagination.vue"))
